import { memo } from 'react';
import { getOrderedDocumentTypes } from '../../../utils/documentTypeUtils';

/**
 * 文書種別セレクトボックス
 *
 * DOCUMENT_TYPE_ORDER_BY_INSURANCE_TYPE で定義された順に全文書種別を表示する。
 * is_enabled が false の種別はグレー表示・選択不可（disabled）とする。
 *
 * @param {Object} props
 * @param {number} props.insuranceType - 保険種別（INSURANCE_TYPE.LIFE / SONPO）
 * @param {number|null} props.selectedId - 選択中の文書種別 ID
 * @param {function(number|null): void} props.onChange - 選択変更コールバック
 * @param {Array} props.documentTypesAccess - 文書種別マスタ（is_enabled を含む）
 */
const DocumentTypeSelect = ({ insuranceType, selectedId, onChange, documentTypesAccess }) => {
  // 全文書種別を表示順に並べる（is_enabled に関わらず全件）
  const options = getOrderedDocumentTypes(documentTypesAccess, insuranceType);

  const handleChange = (e) => {
    const val = e.target.value;
    // 空文字（「指定なし」選択）は null に変換してコールバックへ渡す
    onChange(val ? Number(val) : null);
  };

  return (
    <div className="select-container select-box ver04 selection-option first-mb">
      <select
        className="document-type-select solicitor-select"
        value={selectedId ?? ''}
        onChange={handleChange}
      >
        <option value="">指定なし</option>
        {options.map((opt) => (
          // is_enabled が false の種別は disabled にしてグレー表示
          <option key={opt.id} value={opt.id} disabled={!opt.is_enabled}>
            {opt.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default memo(DocumentTypeSelect);
